import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { ApplianceStatus } from 'libs/appliances/src/lib/models/appliance-status.model';
import { SnSize } from '@lib/common/types';
import { SnApplianceStatus } from 'libs/api/entities/src/lib/appliance';

@Component({
  selector: 'sn-appliances-status',
  templateUrl: './appliances-status.component.html',
  styleUrls: ['./appliances-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppliancesStatusComponent {
  @Input()
  public stats: ApplianceStatus;

  @Input()
  public size: SnSize = 'xs';

  @Input()
  get outlined(): boolean {
    return this._outlined;
  }
  set outlined(value: boolean) {
    this._outlined = coerceBooleanProperty(value);
  }

  @Input()
  get displayLabels(): boolean {
    return this._displayLabels;
  }
  set displayLabels(value: boolean) {
    this._displayLabels = coerceBooleanProperty(value);
  }

  @Input()
  get displayZeroCounts(): boolean {
    return this._displayZeroCounts;
  }
  set displayZeroCounts(value: boolean) {
    this._displayZeroCounts = coerceBooleanProperty(value);
  }

  @Output()
  public readonly itemClick = new EventEmitter<SnApplianceStatus>();

  public readonly APPLIANCE_STATUS = SnApplianceStatus;

  private _outlined = false;
  private _displayLabels = false;
  private _displayZeroCounts = false;

  constructor() {}

  public onChipClick(status: SnApplianceStatus): void {
    this.itemClick.emit(status);
  }
}
